import { styled } from '@mui/system'
import { Alert } from '@mui/material'

const AlertSystem = styled(Alert)(() => ({
	backgroundColor: '#535660',
	fontFamily: 'Gilroy-Medium, sans-serif',
	fontSize: '1.0625rem',
	fontWeight: 500,
	padding: '12px 23px',
}))

export { AlertSystem }
